var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/* eslint-disable max-params */


import { createElement, Component } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';

var safeTimerFactory = function safeTimerFactory(setFn, clearFn, propName, hocName) {
  return function (Target) {
    var SafeTimer = function (_Component) {
      _inherits(SafeTimer, _Component);

      function SafeTimer(props, context) {
        _classCallCheck(this, SafeTimer);

        var _this = _possibleConstructorReturn(this, (SafeTimer.__proto__ || Object.getPrototypeOf(SafeTimer)).call(this, props, context));

        _this.unsubscribers = [];
        _this[propName] = _this[propName].bind(_this);
        return _this;
      }

      _createClass(SafeTimer, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.unsubscribers.forEach(function (unsubscribe) {
            return unsubscribe();
          });
          this.unsubscribers = [];
        }
      }, {
        key: propName,
        value: function value() {
          var id = setFn.apply(undefined, arguments);

          var unsubscriber = function unsubscriber() {
            return clearFn(id);
          };

          this.unsubscribers.push(unsubscriber);
          return unsubscriber;
        }
      }, {
        key: 'render',
        value: function render() {
          return createElement(Target, _extends({}, this.props, _defineProperty({}, propName, this[propName])));
        }
      }]);

      return SafeTimer;
    }(Component);

    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(Target, hocName))(SafeTimer);
    }

    return SafeTimer;
  };
};

export default safeTimerFactory;